import React, { useCallback, useState } from 'react';

import { Roles } from '@/common/constants';
import { useUpdateEmployeeRoleQuery } from '@/modules/employee/Employee/queries';

import useUserVerificationStatusStore from '../stores/useUserVerificationStatus.store';

import ProvideFullAccessConfirmModal from './ProvideFullAccessConfirmModal';
import ProvideFullAccessErrorModal from './ProvideFullAccessErrorModal';
import ProvideFullAccessSuccessModal from './ProvideFullAccessSuccessModal';

interface Props {
  onSetVisible: (value: boolean) => void;
}

const ProvideFullAccessModal: React.FC<Props> = ({ onSetVisible }) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  const employeeId = useUserVerificationStatusStore((state) => state?.state?.employeeId);
  const fullName = useUserVerificationStatusStore((state) => state?.state?.fullName);
  const setState = useUserVerificationStatusStore((state) => state?.setState);

  const { updateEmployeeRole, isLoading } = useUpdateEmployeeRoleQuery();

  const handleClose = useCallback(() => {
    onSetVisible(false);
  }, [onSetVisible]);

  const handleSubmit = useCallback(async () => {
    try {
      await updateEmployeeRole({
        employeeId,
        role: Roles.employee,
      });
      setState({ roleType: Roles.employee });
      setIsSuccess(true);
    } catch {
      setIsError(true);
    }
  }, [employeeId, setState, updateEmployeeRole]);

  if (isSuccess) {
    return (
      <ProvideFullAccessSuccessModal
        fullName={fullName}
        onClose={handleClose}
      />
    );
  }

  if (isError) {
    return (
      <ProvideFullAccessErrorModal
        onSetVisible={onSetVisible}
        onSubmit={handleSubmit}
      />
    );
  }
  
  return (
    <ProvideFullAccessConfirmModal
      onSubmit={handleSubmit}
      onSetVisible={onSetVisible}
      onClose={handleClose}
      isLoading={isLoading}
    />
  );
};

export default ProvideFullAccessModal;
